import { gql, useQuery } from '@apollo/client';
import type { MembersQueryQuery } from 'src/gql/graphql';

const MEMBERS_QUERY = gql`
  query MembersQuery {
    members {
      readOnly
      avatar
      tools
      name
      id
    }
  }
`;

export const useMembers = () => {
  const { data, fetchMore, refetch, loading } = useQuery<MembersQueryQuery>(MEMBERS_QUERY);

  console.log(data);

  return {
    members: data?.members ?? [],
    loading,
    fetchMore,
    refetch,
  };
};
